import { Component } from '@angular/core';
var HrComponent = /** @class */ (function () {
    function HrComponent() {
    }
    HrComponent.decorators = [
        { type: Component, args: [{
                    selector: 'horizontal-rule',
                    template: '<hr>'
                }] }
    ];
    return HrComponent;
}());
export { HrComponent };
//# sourceMappingURL=hr.component.js.map